module.exports = __webpack_public_path__ + "img/noise.e7f2a273.gif";